import { Heart } from "lucide-react";

export const FavButton = ({ m, testid }) => {
  const on = m.favs.has(m.current.path);
  return <button onClick={() => m.pl.toggleFav(m.current.path)} title={on ? "Remove from Favorites" : "Add to Favorites"} aria-pressed={on} className={on ? "text-[#F87171]" : "text-[#7A7468] hover:text-[#F87171]"} data-testid={testid}><Heart className={`h-3.5 w-3.5 ${on ? "fill-[#F87171]" : ""}`} /></button>;
};
